iScreenWizard.factory('Rapporttemplate', function ($q, Ajax) {

    var data = {};

    data.all = function(params) {
        if (typeof params === 'undefined') {
            params = {};
        }
        return $q(function (resolve, reject) {
            Ajax.get('rapporttemplate', params).then(function (response) {
                var rapporttemplates = response.data;
                resolve(rapporttemplates);
            }, reject);
        });
    };

    data.get = function(id) {
        return $q(function (resolve, reject) {
            Ajax.get('rapporttemplate/'+id).then(function (response) {
                var rapporttemplate = response.data;
                resolve(rapporttemplate);
            }, reject);
        });
    };

    return data;
});